































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { CoreStoreState } from '@/core';
import { RootStoreState } from '@/store';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { SwForm, SwFormRow, SwFormRowError } from '@libs-uuif/shared/sw-form';
import { State, namespace } from 'vuex-class';
import { UnifiedInsightsStoreState } from '../unified-insights.store';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { displayWidgetPreview } from '../widgets-configuration/widget-preview/widget-preview-mapping';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { timeFrameMapping } from '../widgets-configuration/widget-constants';

const cssPrefix = 'insert-widget-fields';
const unifiedInsightsStoreModule = namespace('UnifiedInsightsStoreModule');

@Component({
  components: {
    SwActionBar,
    SwActionBarItem,
    SwTextfield,
    SwSelect,
    SwForm,
    SwFormRow,
    SwFormRowError,
  },
  directives: {
    tooltip,
  },
})

export default class InsertWidgetFields extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ required: true })
  widgetsData: any;

  @Prop({ required: true })
  selectedTabDataGroup: string;

  @Prop({ required: true })
  closeModal: any;

  @Prop({ required: false, type: Number, default: null })
  selectedWidgetIndex: number;

  @Prop({ required: false, type: Boolean, default: false })
  tabChanged: boolean;

  @unifiedInsightsStoreModule.State
  widgets: UnifiedInsightsStoreState['widgets'];

  @State((state: RootStoreState) => state.CoreStoreModule.tenantName)
  readonly tenantName: CoreStoreState['tenantName'];

  @State((state: RootStoreState) => state.CoreStoreModule.tenantGroups)
  readonly tenantGroups: CoreStoreState['tenantGroups'];

  @unifiedInsightsStoreModule.Mutation
  insertWidget: VuexMappedMutation<UnifiedInsightsStoreState['widgets']>;

  @unifiedInsightsStoreModule.Mutation
  replaceWidget: VuexMappedMutation<UnifiedInsightsStoreState['widgets']>;

  @State((state: RootStoreState) => state.CoreStoreModule.nsmTenentMode)
  readonly nsmTenentMode: CoreStoreState['nsmTenentMode'];

  titleMaxLength: number = 36;
  refreshRateMin: number = 60;
  refreshRateMax: number = 3600;
  isShowErrorMsg: boolean = false;

  defaultWidgetDetails: any = {
    title: '',
    widget: '',
    timeframe: 'Last 24 Hours',
    refreshRate: '60',
    groupScope: 'All groups',
    disableTimeFrame: false,
    preview: {},
  };

  groupScopeOptions: SelectOption[] = [
    {
      id: 'All groups',
      label: 'All groups',
    },
  ];

  errorsObj: any = {
    title: [],
    refreshRate: [],
  };

  usedTitles: string[] = [];
  widgetOptions: SelectOption[] = [];
  timeFrameOptions: SelectOption[] = [];
  widgetDropdownMaxHeight: number = 388;
  widgetPosition: object = { x: 0, y: 0 };

  widgetDetails: any = { ...this.defaultWidgetDetails };
  disableSaveButton: boolean = true;
  initialWidgetEdit: boolean = false;
  groupBy: string;
  previousName: string;

  /**
  * @desc This function will be called whenever the value of widget changes from the dropdown.
  */
  @Watch('widgetDetails.widget', {
    deep: true,
    immediate: true,
  })
  widgetTimeFrame() {
    const widget = _.find(this.widgetsData, {
      name: this.widgetDetails.widget,
    });
    if (widget) {
      this.widgetDetails.disableTimeFrame = widget.disableTimeFrameDropdown;
      this.timeFrameOptions = widget.disableTimeFrameDropdown
        ? []
        : [
          ...widget.timeFrameOptions.map((option: any) => ({
            id: option,
            label: option,
          })),
        ];
      this.timeFrameOptions = this.configureTimeFrameOptions(this.timeFrameOptions);
      if (this.initialWidgetEdit) {
        this.initialWidgetEdit = false;
      } else {
        this.widgetDetails.preview = displayWidgetPreview(widget.preview);
        this.widgetDetails.timeframe =
          this.timeFrameOptions.length > 0 ? this.timeFrameOptions[0].id : '';
      }
    }
  }

  /**
   * @desc This function will be called whenever the value of disableSaveButton changes.
  */
  @Watch('disableSaveButton', { immediate: true })
  enableSave() {
    this.$emit('disableSave', this.disableSaveButton);
  }

  @Watch('tenantGroups', { immediate: true })
  fetchGroups() {
    this.groupScopeOptions.splice(1, this.groupScopeOptions.length);
    const newGroupOptions: SelectOption[] = this.tenantGroups.map(
      (group: { groupId: string; groupName: string; devices: any }) => {
        return {
          id: group.groupId,
          label: group.groupName,
        };
      },
    );
    this.groupScopeOptions = [...this.groupScopeOptions, ...newGroupOptions];
  }

  /**
  * @desc This function will be called to validate the title that it is non empty.
  */
  validateTitle() {
    if (this.widgetDetails.title.trim() === '') {
      return true;
    }
    return false;
  }

  updateWidgetTitle(value: string) {
    this.widgetDetails.title = value?.slice(0, this.titleMaxLength);
  }
  /**
  * @desc This function will be called to filter the time frame options when tenent mode is ESSENTIAL
  * and data group is firewall.
  */
  configureTimeFrameOptions(timeFrameOptions: SelectOption[] = []) : SelectOption[] {
    return timeFrameOptions.length > 0 ?
      (this.nsmTenentMode !== 'ADVANCED' && this.selectedTabDataGroup === 'firewall' ?
        timeFrameOptions.slice(0, 2) :
        [...timeFrameOptions]) :
      [];
  }

  // This function will be called to validate the input fields
  validateTitleField(): boolean {
    const errorMsg = [];
    this.validateTitle()
      ? errorMsg.push('Title cannot be empty.')
      : this.usedTitles.includes(
          this.widgetDetails.title.trim()
              .toLowerCase(), // prettier-ignore
        ) && errorMsg.push('Title is already used by a widget.');

    this.errorsObj['title'] = errorMsg;
    if (this.errorsObj.title.length === 0) {
      return true;
    }
    return false;
  }

  // This function will be called to validate the input fields
  validateRefreshRateField(): boolean {
    const errorMsg = [];
    this.widgetDetails.refreshRate = `${Math.floor(this.widgetDetails.refreshRate)}`;
    (Number(this.widgetDetails.refreshRate) < this.refreshRateMin ||
      Number(this.widgetDetails.refreshRate) > this.refreshRateMax) &&
      errorMsg.push(
        `Refresh rate must be in range of ${this.refreshRateMin} to ${this.refreshRateMax} with both inclusive.`,
      );

    this.errorsObj['refreshRate'] = errorMsg;
    if (this.errorsObj.refreshRate.length === 0) {
      return true;
    }
    return false;
  }

  @Watch('widgetDetails', {
    deep: true,
    immediate: true,
  })
  changeButtonStatus() {
    if (this.validateTitleField() && this.validateRefreshRateField()) {
      this.disableSaveButton = false;
    } else {
      this.disableSaveButton = true;
    }
  }

  /**
   * @desc This function will be called on component mount.
  */
  async onSave() {
    const selectedWidget: any = _.find(this.widgetsData, {
      name: this.widgetDetails.widget,
    });
    const widgetToInsert: any = {
      ...this.widgetPosition,
      ...selectedWidget,
      h: 7,
      w: selectedWidget.w,
      i: this.widgetDetails.title,
      title: this.widgetDetails.title.trim(),
      dataGroup: this.selectedTabDataGroup,
      widgetDropDownOption: this.widgetDetails.widget,
      component: selectedWidget.component,
      endpoint: selectedWidget.endpoint,
      timeframe: this.widgetDetails.disableTimeFrame
        ? ''
        : this.widgetDetails.timeframe,
      refreshRate: Number(this.widgetDetails.refreshRate),
      disableTimeFrameDropdown: this.widgetDetails.disableTimeFrame,
      groupBy:
        this.widgetDetails.widget === this.previousName
          ? this.groupBy
          : selectedWidget.groupBy,
    };
    if (
      this.selectedTabDataGroup === 'firewall' &&
      this.widgetDetails.groupScope !== 'All groups'
    ) {
      const group = this.tenantGroups.find(
        (group: any) => group.groupId === this.widgetDetails.groupScope,
      );
      const groupName = group ? group.groupName : '';
      const devices = group ? group.devices : [];
      widgetToInsert.tenantGroup = {
        groupName,
        devices,
        groupId: this.widgetDetails.groupScope,
      };
    }

    if (this.selectedWidgetIndex !== null) {
      this.replaceWidget({
        widgetIndex: this.selectedWidgetIndex,
        widgetDetails: widgetToInsert,
      });
    } else {
      await this.insertWidget(widgetToInsert);
      this.$emit('widgetAdded');
    }
    this.closeModal();
  }

  /**
  * @desc This function will be called on component mount
  */
  mounted() {
    this.widgetPosition = {
      x: 0,
      y: this.widgets.length > 0
          ? this.widgets[this.widgets.length - 1].y + 1
          : 0,
    };
    this.usedTitles = _.map(this.widgets, 'title')
    .map(title => title.toLowerCase()); // prettier-ignore
    const sortedData = _.orderBy(this.widgetsData, ['name'], ['asc']);
    this.widgetOptions = [
      ...sortedData.map((widget: any) => ({
        id: widget.name,
        label: widget.name,
        value: widget.name,
        labelStringRep: widget.name,
      })),
    ];
    this.widgetDetails.widget =
      this.widgetOptions.length > 0 ? this.widgetOptions[0].id : '';

    if (this.selectedWidgetIndex !== null) {
      const selectedWidgetDetails: any = this.widgets[this.selectedWidgetIndex];
      this.groupBy = selectedWidgetDetails.groupBy;
      this.previousName = selectedWidgetDetails.name;
      this.usedTitles.splice(
        this.usedTitles.indexOf(selectedWidgetDetails.title.toLowerCase()),
        1,
      );
      this.widgetPosition = {
        x: selectedWidgetDetails.x,
        y: selectedWidgetDetails.y,
      };
      if (!this.tabChanged) {
        this.initialWidgetEdit = true;
        this.disableSaveButton = false;
        this.widgetDetails = {
          ...this.defaultWidgetDetails,
          title: selectedWidgetDetails.title,
          widget: selectedWidgetDetails.widgetDropDownOption,
          timeframe: selectedWidgetDetails.timeframe,
          refreshRate: `${selectedWidgetDetails.refreshRate}`,
          disableTimeFrame: selectedWidgetDetails.disableTimeFrameDropdown,
          preview: displayWidgetPreview(selectedWidgetDetails.preview),
        };
      }
      if (selectedWidgetDetails.tenantGroup) {
        this.widgetDetails.groupScope =
          selectedWidgetDetails.tenantGroup.groupId || 'All groups';
      }
    }
  }
  onChangeTimeFrame(value: string) {
    if (this.nsmTenentMode === 'ADVANCED' &&
      this.selectedTabDataGroup === 'firewall' &&
      value === timeFrameMapping.last30Days) {
      confirmService.confirm({
        message: this.$t('spog.unifiedInsights.timeFrameTitle')
        .toString(),
        title: this.$t('spog.unifiedInsights.timeFrameMsg')
        .toString(),
        status: 'informational',
        buttons: [
          {
            key: 'cancel',
            name: this.$t('common.cancel')
            .toString(),
          },
          {
            key: 'proceed',
            name: this.$t('spog.unifiedInsights.proceed')
            .toString(),
            isDefault: true,
          },
        ],
      })
      .then((response: any) => {
        if (response === 'proceed') {
          this.widgetDetails.timeframe = value;
        }
      });
    } else {
      this.widgetDetails.timeframe = value;
    }
  }
}
